import styled from 'styled-components';

export const Container = styled.div`
  button {
    background: none;
    border: none;
    outline: none;
  }

`;

export const Column = styled.div`
align-items: flex-start;
display: flex;
flex-direction: column;
justify-content: flex-start;
width: 100%;

  input{
    margin-bottom: 32px;
  }

`;

export const ModalTitle = styled.h3`
color: ${({ theme }) => theme.colors.gray.shark};
margin-bottom: 24px;

span {
  font-weight: 400;
}
`;

export const Row = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  justify-content: space-between;

  &+&{
    margin-top: 16px;
  }

  img{
    border-radius: 50%;
    height: 36px;
    margin-right: 8px;
  }

  label{
    color: ${({ theme }) => theme.colors.gray.trout};
    font-size: 16px;
  }

  label + span{
    color: ${({ theme }) => theme.colors.gray.oslo};
  }

  button{
    margin-left: 16px;
    max-width: 124px;
  }

  @media screen and (max-width: 540px){
      label + span {
        font-size: 12px;
      }
  }
`;

export const InviteContainer = styled.div`
  grid-template-columns: 65% 32%;
  grid-template-rows: 1fr 1fr;
  display: grid;
  width: 100%;
  margin-bottom: 16px;
  column-gap: 3%;

  @media screen and (max-width: 540px) {
      button {
        grid-column: 1/-1;
      }
  }

  @media screen and (min-width: 540px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
`;
